import { Component } from '@angular/core';
import { InvestisseurType } from '@lib/models/generated/graphql';
import { AuthService } from '@lib/services/auth-service.service';
import { OuiBannerAction } from 'omnium-ui/banner';
import { OuiDialogService } from 'omnium-ui/dialog';
import { Subscription } from 'rxjs';
import { NoneActiveHabilitationMessageComponent } from 'src/app/components/none-active-habilitation-message/none-active-habilitation-message.component';

export type conseilConfigSelector = {
  isSouscription: boolean;
  investisseurType: InvestisseurType;
  natureOperationId: number;
};
@Component({
  selector: 'app-my-fiches',
  templateUrl: './my-fiches.component.html',
  styleUrls: ['./my-fiches.component.scss'],
})
export class MyFichesComponent {
  noHabilAction: OuiBannerAction = {
    label: 'En savoir plus',
    action: () => {
      this.openHabilitationMessage();
    },
  };
  isNotHabilitedWarning: boolean = false;
  userHabilitationCheckSubscription: Subscription;

  constructor(private dialogService: OuiDialogService, private authService: AuthService) {}

  ngOnInit() {
    this.userHabilitationCheckSubscription = this.authService.userHabilitationCheck.subscribe(value => {
      if (value) {
        this.isNotHabilitedWarning = !this.authService.isSomeHabilitationValid();
      }
    });
  }

  openHabilitationMessage() {
    this.dialogService.openDialog(
      NoneActiveHabilitationMessageComponent,
      {
        title: 'Aucune habilitation active',
      },
      'auto',
      '662px'
    );
  }
}
